export default {
  methods: {
    routeOnError(httpErrorCode) {
        // Method to route to error pages following and error received from an API request
        switch(httpErrorCode) {
            case 401:
                return "/login"
                break
            case 403:
                return "/error/403"
                break
            case 404:
                return "/error/404"
                break
            default:
                return "/error/500"
        }
    }    
  }
}